// JavaScript
import client from './client';

export default {
  sendMessage(params) {
    return client.post('/trade_offers/trades/request_trade')
      .query(params)
      .end();
  },

  fetchTradeOffers(params) {
    return client.get('/trade_offers/trades/index')
      .query(params)
      .end((err, res) => {
        if (err) {
          console.error('API error:', err);
        } else {
          console.log('Trade offers response:', res && res.body);
        }
      });
  },

  acceptTradeOffer(params) {
    return client.post('/trade_offers/trades/accept')
      .query(params)
      .end();
  },

  rejectTradeOffer(params) {
    return client.post('/trade_offers/trades/reject')
      .query(params)
      .end();
  },

  cancelTradeRequest(params) {
    return client.post('/trade_offers/trades/cancel')
      .query(params)
      .end();
  }
};


// WEBPACK FOOTER //
// ./app/sources/api/tradeRequestApi.js